import React from "react";
import { Box } from "@mui/material";
import { SmartPhone01Icon } from "@hugeicons-pro/core-stroke-rounded";
import appleAppStore from "../assets/images/apple-app-store.svg";
import googlePlayStore from "../assets/images/google-play-badge.png";
import { useTranslation } from "react-i18next";
import { useBrandingContext } from "context/BrandingContext";
import { Inline } from "components/layout/reusableLayouts";
import StatusPage from "components/common/StatusPage";

const Mobile = () => {
  const { t } = useTranslation();
  const { platform } = useBrandingContext();
  const supportEmail = platform?.email || "support@outpave.com";

  const stores = [
    {
      href:
        platform?.iosAppUrl ||
        "https://apps.apple.com/us/app/outpave/id1581589001",
      badge: appleAppStore,
      alt: "Apple App Store",
    },
    {
      href:
        platform?.androidAppUrl ||
        "https://play.google.com/store/apps/details?id=com.outpave.spend",
      badge: googlePlayStore,
      alt: "Google Play Store",
    },
  ];

  return (
    <StatusPage
      title={t("Registered for mobile access")}
      message={t("mobileAccessRegistered")}
      icon={SmartPhone01Icon}
      supportEmail={supportEmail}
    >
      <Inline gap="var(--space-5)" justify="center">
        {stores.map((store) => (
          <a
            key={store.alt}
            href={store.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Box
              component="img"
              src={store.badge}
              alt={store.alt}
              sx={{ height: 48, display: "block" }}
            />
          </a>
        ))}
      </Inline>
    </StatusPage>
  );
};

export default Mobile;
